import React from 'react'
import { Button } from '@material-ui/core'
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt'
import { useForm } from '../../../providers'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
    btn: {
        [theme.breakpoints.up('sm')]: {
            width: '50%',
        },
        textTransform: 'none',
        fontSize: '1rem',
        marginBottom: theme.spacing(4),
        marginTop: theme.spacing(4),
        padding: '0.5rem 1.5rem',
        backgroundColor: '#FF2400',
    },
}))

export const NextButton = () => {
    const { onSubmitPartOne } = useForm()
    const classes = useStyles()
    return (
        <Button
            className={classes.btn}
            onClick={onSubmitPartOne}
            variant="contained"
            color="primary"
            size="large"
            fullWidth
            endIcon={<ArrowRightAltIcon />}
        >
            Next
        </Button>
    )
}
